import { render, staticRenderFns } from "./fireDetectionAlarmSystemInfoDetail.vue?vue&type=template&id=c34dd01c"
import script from "./fireDetectionAlarmSystemInfoDetail.vue?vue&type=script&lang=js"
export * from "./fireDetectionAlarmSystemInfoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c34dd01c')) {
      api.createRecord('c34dd01c', component.options)
    } else {
      api.reload('c34dd01c', component.options)
    }
    module.hot.accept("./fireDetectionAlarmSystemInfoDetail.vue?vue&type=template&id=c34dd01c", function () {
      api.rerender('c34dd01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/fdas/fireDetectionAlarmSystemInfoDetail.vue"
export default component.exports